import { render } from "./NavigationButtons.vue?vue&type=template&id=2cde0436&scoped=true&ts=true"
import script from "./NavigationButtons.vue?vue&type=script&lang=ts"
export * from "./NavigationButtons.vue?vue&type=script&lang=ts"

import "./NavigationButtons.vue?vue&type=style&index=0&id=2cde0436&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cde0436"]])

export default __exports__